import {Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import moment from 'moment';
import * as _ from 'lodash';
import {BusinessEntityService} from 'src/app/services/businessEntity.service';
import BusinessEntity from 'src/app/services/businessEntity.model';
import {DeviceService} from 'src/app/services/device.service';
import DeviceModel from 'src/app/services/device.model';
import {DeviceMovementService} from 'src/app/services/deviceMovement.service';
import DeviceMovementModel from 'src/app/services/deviceMovement.model';
import CustomerDeviceModel from 'src/app/services/customerDevice.model';
import {CustomerDeviceService} from 'src/app/services/customerDevice.service';
import DeviceOnHandModel from 'src/app/services/deviceOnhand.model';
import { ToastrService } from 'ngx-toastr';
import { LocationStrategy } from '@angular/common';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import { DeviceOnhandService } from 'src/app/services/device-onhand.service';
import { BatchLoader } from 'src/app/Utils/batch-loader.util';

declare var $: any;

@Component({
  selector: 'app-device-onhand',
  templateUrl: './device-onhand.component.html',
  styleUrls: ['./device-onhand.component.scss']
})
export class DeviceOnHandComponent implements OnInit, OnDestroy{
  public deviceOnhands: Array<DeviceOnHandModel>;
  public deviceOnHand: DeviceOnHandModel;
  public device: DeviceModel;
  public businessEntities: Array<BusinessEntity>;
  public businessEntitie: BusinessEntity;
  public deviceMovement: DeviceMovementModel;
  public customerDevices: Array<CustomerDeviceModel>;
  public customerDevice: CustomerDeviceModel;
  public nonMappedDevice: CustomerDeviceModel;
  public loginPersonType: string;
  public performing_by: string;
  public responseLoader: boolean;
  public date: string;
  public inactive_date: string;
  public isTabledisplay: boolean;
  public customersArray = new Array();
  public currentpagenum: number = 1;
  public noofitemsPerPage: number = 10;
  public dupCurrentPageNum: number;
  public deassigndate: any;
  public map_todate: string;
  public moveto_inventorydate: any;
  public businessName: string;
  public currentDate: string;
  public inventory_inactive_date: string;
  public hub_inactive_date: any;
  public pgLoad = false;
  public aquDeviceOnHand: any[] = [];
  public displayAquDeviceOnHand: any[] = [];
  public search: string;
  public selectedLocation: string;
  public duplicateAquDeviceOnHand: any[] = [];
  public keyword:string;
  public item:any;
  public NoDataMessage:boolean = false;
  public activePageNo: number;
  public isSearchedClicked: boolean;
  public listLoader = false;
  public noList = false;
  public isFiltering = false;

  public showDeassignPopup = false;
  public showCustomerInactivePopup = false;
  public showInventoryInactivePopup = false;
  public showHubInactivePopup = false;
  public showMapPopup = false;
  public showMoveToInventoryPopup = false;
  public showAssignTintoPopup = false;

  private batchLoader: BatchLoader<any>;
  private searchTimeout: any;
  private scrollTimeout: any;

  public closePopups(): void {
    this.showDeassignPopup = false;
    this.showCustomerInactivePopup = false;
    this.showInventoryInactivePopup = false;
    this.showHubInactivePopup = false;
    this.showMapPopup = false;
    this.showMoveToInventoryPopup = false;
    this.showAssignTintoPopup = false;
  }

  constructor(public deviceOnhandService: DeviceOnhandService, public deviceService: DeviceService, public businessEntityService: BusinessEntityService, public deviceMovementService: DeviceMovementService, public customerDeviceService: CustomerDeviceService, private toastr: ToastrService,
    private locationStrategy: LocationStrategy, private previousRouteService: PreviousRouteService
  ) {
    this.customerDevice = new CustomerDeviceModel();
    this.businessEntitie = new BusinessEntity();
    this.deviceMovement = new DeviceMovementModel();
    this.initializeBatchLoader();
  }

  private initializeBatchLoader(): void {
    this.batchLoader = new BatchLoader<any>(
      () => this.aquDeviceOnHand,
      (updatedList) => {
        this.displayAquDeviceOnHand = updatedList;
        this.noList = updatedList.length === 0;
      },
      undefined,
      (loading) => this.listLoader = loading
    );
  }

  @HostListener('window:scroll', [])
  public onWindowScroll(): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 &&
        !this.batchLoader?.isLoading() && !this.isFiltering) {
        this.batchLoader?.loadNextBatch();
      }
    }, 50);
  }

  public async ngOnInit() {
    try {
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
       // loginperson type details
      this.loginPersonType = localStorage.getItem('loginPersonType');
      // login person Business name
      this.performing_by = localStorage.getItem('loginBusinessName');
      this.keyword = 'businessName';
      this.initializedatePicker();
      this.initializeinactivedatePicker();
      this.initializemaptodevicePicker();
      this.initializemovetoInventoryPicker();
      this.initializeinventoryinactivedatePicker();
      this.initializehubinactivedatePicker();
      this.isSearchedClicked = false;
      this.activePageNo = 1;
      this.currentpagenum = 1;
      this.dupCurrentPageNum = 1;
      this.currentDate = moment(new Date()).format('DD-MMM-YYYY h:mm:ss a');
      this.deassigndate = (moment(new Date()).format('DD-MMM-YYYY')).toString(); // "2020-05-20"
      this.inactive_date = (moment(new Date()).format('DD-MMM-YYYY')).toString(); // "2020-05-20"
      this.inventory_inactive_date = (moment(new Date()).format('DD-MMM-YYYY')).toString(); // "2020-05-20"
      this.hub_inactive_date = (moment(new Date()).format('DD-MMM-YYYY')).toString(); // "2020-05-20"
      this.map_todate = (moment(new Date()).format('DD-MMM-YYYY')).toString(); // "2020-05-20"
      this.moveto_inventorydate = (moment(new Date()).format('DD-MMM-YYYY')).toString(); // "2020-05-20"
      this.aquDeviceOnHand = [];
      this.isTabledisplay = false;
      this.customersArray = [];
      this.selectedLocation = 'All';
      await this.getLocationData();
      let promiseResults = new Array();
      await Promise.all([
        await this.businessEntityService.getAllBusiness(),
        await this.customerDeviceService.getAllNonMapped(),
      ]).then((resolve) => {
        promiseResults = resolve;
      }).catch((reject) => {
        this.toastr.error(reject);
      });
      let businesses = promiseResults[0];
      this.nonMappedDevice = promiseResults[1];
      this.businessEntities = businesses.filter((obj: any) => {
          return obj.businessType[0] && obj.businessType[0].businessTypeID != '618a18ac0f339c001e991b08';
      });
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

//To cancel ongoing requests and unsubscribe from subscriptions.
public ngOnDestroy(): void {
  this.businessEntityService.cancelOnGoingHttpRequests();
  this.customerDeviceService.cancelOnGoingHttpRequests();
  this.deviceOnhandService.cancelOnGoingHttpRequests();
  this.batchLoader?.markAsDestroyed();
  this.batchLoader?.reset();
}

  public async getLocationData() {
    this.aquDeviceOnHand = [];
    this.duplicateAquDeviceOnHand = [];
    this.responseLoader = false;
    this.isTabledisplay = false;
    try {
      this.deviceOnhands = await this.deviceOnhandService.getLocationData();
      for (let i = 0; i < this.deviceOnhands.length; i++) {
        if (this.deviceOnhands[i].device.isCalorimeter == false) {
          this.aquDeviceOnHand.push(this.deviceOnhands[i]);
          this.duplicateAquDeviceOnHand.push(this.deviceOnhands[i]);
        }
      }
      this.responseLoader = true;
      this.batchLoader?.reset();
      await this.batchLoader?.loadNextBatch(true);
    } catch (error: any) {
      this.responseLoader = true;
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  /*Get DeviceOnHandDetails by id*/
  public async getDeviceOnHandDetailsById(id: string) {
    try {
      this.deviceOnHand = this.deviceOnhands.find(device => device && device.device_id === id);
      return this.deviceOnHand;
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }



  // get device details by device id
  public async getDeviceDetailsById(id: string) {
    try {
      let promiseResults = new Array();
      await Promise.all([
        await this.deviceService.getOneByID(id),
        await this.businessEntityService.getAllBusiness(),
      ]).then((resolve) => {
        promiseResults = resolve;
      }).catch((reject) => {
        this.toastr.error(reject);
      });
      this.device = promiseResults[0];
      this.businessEntities = promiseResults[1];
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  public formatDateForPayload(dateVal: any): string {
    if (!dateVal) {
      return moment().format('YYYY-MM-DD');
    }
    const m = moment(dateVal, ['DD-MMM-YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
    if (m.isValid()) {
      return m.format('YYYY-MM-DD');
    }
    const mFallback = moment(dateVal);
    if (mFallback.isValid()) {
      return mFallback.format('YYYY-MM-DD');
    }
    return moment().format('YYYY-MM-DD');
  }

  // Deassign fun
  public async deassignFun(deviceId: string) {
    let rawDate = $('#startdate').val() || this.deassigndate;
    let deassigndate = this.formatDateForPayload(rawDate);
    let dt = new Date();
    let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    if (!deassigndate) {
      this.toastr.error('Please select date');
      return false;
    }
    if (this.deviceMovement.comment === null || this.deviceMovement.comment === '' || this.deviceMovement.comment === undefined) {
      this.toastr.error('Please enter reason');
      return false;
    }
    this.deviceMovement.device_id = deviceId;
    this.deviceMovement.from_loc = 1;
    this.deviceMovement.to_loc = 3;
    this.deviceMovement.action_name = 'De_Assign';
    this.deviceMovement.date = deassigndate;
    this.deviceMovement.time = dtime;
    this.deviceMovement.created_by = this.loginPersonType;
    this.deviceMovement.updated_by = this.loginPersonType;
    try {
      this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      this.toastr.success('De-Assigned successfully');
      await this.getLocationData();
      this.closePopups();
      this.deviceMovement = new DeviceMovementModel();
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  // customer inactive fun
  public async customerinActiveFun(deviceId: string) {
    let rawDate = $('#inactivedate').val() || this.inactive_date;
    let inactive_date = this.formatDateForPayload(rawDate);
    let dt = new Date();
    let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    if (!inactive_date) {
      this.toastr.error('Please select date');
      return false;
    }
    if (this.deviceMovement.comment === null || this.deviceMovement.comment === '' || this.deviceMovement.comment === undefined) {
      this.toastr.error('Please enter reason');
      return false;
    }
    this.deviceMovement.from_loc = 1;
    this.deviceMovement.to_loc = 4;
    this.deviceMovement.to = 'Inactive';
    this.deviceMovement.to_id = null;
    this.deviceMovement.device_id = deviceId;
    this.deviceMovement.action_name = 'InActive';
    this.deviceMovement.date = inactive_date;
    this.deviceMovement.time = dtime;
    this.deviceMovement.created_by = this.loginPersonType;
    this.deviceMovement.updated_by = this.loginPersonType;
    try {
      this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      this.toastr.success('Inactive successfully');
      await this.getLocationData();
      this.closePopups();
      this.deviceMovement = new DeviceMovementModel();
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  // Inventory inactive fun
  public async inventoryinActiveFun(deviceId: string) {
    let rawDate = $('#inventoryinactivedate').val() || this.inventory_inactive_date;
    let inventory_inactive_date = this.formatDateForPayload(rawDate);
    let dt = new Date();
    let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    if (!inventory_inactive_date) {
      this.toastr.error('Please select date');
      return false;
    }
    if (this.deviceMovement.comment == null || this.deviceMovement.comment === '' || this.deviceMovement.comment === undefined) {
      this.toastr.error('Please enter reason');
      return false;
    }
    this.deviceMovement.from_loc = 2;
    this.deviceMovement.to_loc = 4;
    this.deviceMovement.to = 'Inactive';
    this.deviceMovement.to_id = null;
    this.deviceMovement.device_id = deviceId;
    this.deviceMovement.action_name = 'InActive';
    this.deviceMovement.date = inventory_inactive_date;
    this.deviceMovement.time = dtime;
    this.deviceMovement.created_by = this.loginPersonType;
    this.deviceMovement.updated_by = this.loginPersonType;
    try {
      this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      this.toastr.success('Inactive successfully');
      await this.getLocationData();
      this.closePopups();
      this.deviceMovement = new DeviceMovementModel();
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  // hub inactive fun
  public async hubinActiveFun(deviceId: string) {
    let rawDate = $('#hubinactivedate').val() || this.hub_inactive_date;
    let hub_inactive_date = this.formatDateForPayload(rawDate);
    let dt = new Date();
    let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    if (!hub_inactive_date) {
      this.toastr.error('Please select date');
      return false;
    }
    if (this.deviceMovement.comment == null || this.deviceMovement.comment === '' || this.deviceMovement.comment === undefined) {
      this.toastr.error('Please enter reason');
      return false;
    }
    this.deviceMovement.from_loc = 3;
    this.deviceMovement.to_loc = 4;
    this.deviceMovement.to = 'Inactive';
    this.deviceMovement.to_id = null;
    this.deviceMovement.device_id = deviceId;
    this.deviceMovement.action_name = 'InActive';
    this.deviceMovement.date = hub_inactive_date;
    this.deviceMovement.time = dtime;
    this.deviceMovement.created_by = this.loginPersonType;
    this.deviceMovement.updated_by = this.loginPersonType;
    try {
      this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      this.toastr.success('Inactive successfully');
      await this.getLocationData();
      this.closePopups();
      this.deviceMovement = new DeviceMovementModel();
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }


  // mapDeviceFun fun
  public async mapDeviceFun(deviceId: string) {
    let device = await this.deviceService.getOneByID(deviceId);
    let rawDate = $('#Maptodate').val() || this.map_todate;
    let Maptodate = this.formatDateForPayload(rawDate);
    let dt = new Date();
    let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    if (this.businessEntitie.id == null || this.businessEntitie.id === '' || this.businessEntitie.id === undefined) {
      this.toastr.error('Please select business');
      return false;
    }
    if (!Maptodate) {
      this.toastr.error('Please select date');
      return false;
    }
    if (this.deviceMovement.comment === null || this.deviceMovement.comment === '' || this.deviceMovement.comment === undefined) {
      this.toastr.error('Please enter comment');
      return false;
    }
    let itmsArr = _.filter(this.businessEntities, (o) => {
      return o.id === this.businessEntitie.id;
    });
    if (itmsArr.length > 0) {
      this.businessName = itmsArr[0].businessName;
    }
    this.deviceMovement.from_loc = 2;
    this.deviceMovement.to_loc = 1;
    this.deviceMovement.business_id = this.businessEntitie.id;
    this.deviceMovement.to = this.businessName;
    this.deviceMovement.to_id = this.businessEntitie.id;
    this.deviceMovement.device_id = deviceId;
    if (device.device_model_id == 3) {
      this.deviceMovement.isContinuousMonitoring = 1;
    } else {
      this.deviceMovement.isContinuousMonitoring = 0;
    }
    this.deviceMovement.action_name = 'Map';
    this.deviceMovement.date = Maptodate;
    this.deviceMovement.time = dtime;
    this.deviceMovement.created_by = this.loginPersonType;
    this.deviceMovement.updated_by = this.loginPersonType;
    let businessType = await this.businessEntityService.getOneByID(this.businessEntitie.id);
    if (businessType.businessType[0].name == 'Feed Provider' || businessType.businessType[0].name == 'Seed Provider') {
      this.deviceMovement.businessTypeID = businessType.businessType[0].businessTypeID;
    }
    try {
      this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      this.toastr.success('Device mapped to business successfully');
      this.closePopups();
      await this.getLocationData();
      this.deviceMovement = new DeviceMovementModel();
      this.deviceMovement.business_id = undefined;
      this.deviceMovement.comment = '';
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  // move to inventory fun
  public async moveToInventoryFun(deviceId: string) {
    let rawDate = $('#movetoInventorydate').val() || this.moveto_inventorydate;
    let movetoInventorydate = this.formatDateForPayload(rawDate);
    let dt = new Date();
    let dtime = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    if (!movetoInventorydate) {
      this.toastr.error('Please select date');
      return false;
    }
    if (this.deviceMovement.comment == null || this.deviceMovement.comment === '' || this.deviceMovement.comment === undefined) {
      this.toastr.error('Please enter reason');
      return false;
    }
    this.deviceMovement.from_loc = 3;
    this.deviceMovement.to_loc = 2;
    this.deviceMovement.to_id = this.device.id;
    this.deviceMovement.device_id = deviceId;
    this.deviceMovement.action_name = 'Move_to_Inventory';
    this.deviceMovement.date = movetoInventorydate;
    this.deviceMovement.time = dtime;
    this.deviceMovement.created_by = this.loginPersonType;
    this.deviceMovement.updated_by = this.loginPersonType;
    try {
      this.deviceMovement = await this.deviceMovementService.deassignFun(this.deviceMovement);
      this.toastr.success('Moved to inventory successfully');
      await this.getLocationData();
      this.closePopups();
      this.deviceMovement = new DeviceMovementModel();
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  /*date*/
  public initializedatePicker() {
    let that = this;
    let strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let contract_dates = $('#startdate').datepicker({
      maxDate: new Date(),
      onSelect: function(selectedDate: string) {
        let parsedDate = (selectedDate.split('/')[1] + '-' + strArray[(parseInt(selectedDate.split('/')[0]) - 1)] + '-' + selectedDate.split('/')[2]);
        let option = this.id == 'startdate' ? 'minDate' : 'maxDate',
          instance = $(this).data('datepicker'),
          date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
        contract_dates.not(this).datepicker('option', option, date);
        $('#startdate').val(parsedDate);
        that.date = parsedDate;
      }
    });
  }

  /* customer inactivedate*/
  public initializeinactivedatePicker() {
    let that = this;
    let strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let contract_dates = $('#customerinactivepopup').datepicker({
      maxDate: new Date(),
      onSelect: function(selectedDate: string) {
        let parsedDate = (selectedDate.split('/')[1] + '-' + strArray[(parseInt(selectedDate.split('/')[0]) - 1)] + '-' + selectedDate.split('/')[2]);
        let option = this.id == 'customerinactivepopup' ? 'minDate' : 'maxDate',
          instance = $(this).data('datepicker'),
          date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
        contract_dates.not(this).datepicker('option', option, date);
        $('#customerinactivepopup').val(parsedDate);
        that.inactive_date = parsedDate;
      }
    });
  }

  /* inventory inactivedate*/
  public initializeinventoryinactivedatePicker() {
    let that = this;
    let strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let contract_dates = $('#inventoryinactivedate').datepicker({
      maxDate: new Date(),
      onSelect: function(selectedDate: string) {
        let parsedDate = (selectedDate.split('/')[1] + '-' + strArray[(parseInt(selectedDate.split('/')[0]) - 1)] + '-' + selectedDate.split('/')[2]);
        let option = this.id == 'inventoryinactivedate' ? 'minDate' : 'maxDate',
          instance = $(this).data('datepicker'),
          date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
        contract_dates.not(this).datepicker('option', option, date);
        $('#inventoryinactivedate').val(parsedDate);
        that.inventory_inactive_date = parsedDate;
      }
    });
  }

  /* hub inactivedate*/
  public initializehubinactivedatePicker() {
    let that = this;
    let strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let contract_dates = $('#hubinactivedate').datepicker({
      maxDate: new Date(),
      onSelect: function(selectedDate: string) {
        let parsedDate = (selectedDate.split('/')[1] + '-' + strArray[(parseInt(selectedDate.split('/')[0]) - 1)] + '-' + selectedDate.split('/')[2]);
        let option = this.id == 'hubinactivedate' ? 'minDate' : 'maxDate',
          instance = $(this).data('datepicker'),
          date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
        contract_dates.not(this).datepicker('option', option, date);
        $('#hubinactivedate').val(parsedDate);
        that.hub_inactive_date = parsedDate;
      }
    });
  }

  /*map to device date*/
  public initializemaptodevicePicker() {
    let that = this;
    let strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let contract_dates = $('#Maptodate').datepicker({
      maxDate: new Date(),
      onSelect: function(selectedDate: string) {
        let parsedDate = (selectedDate.split('/')[1] + '-' + strArray[(parseInt(selectedDate.split('/')[0]) - 1)] + '-' + selectedDate.split('/')[2]);
        let option = this.id == 'Maptodate' ? 'minDate' : 'maxDate',
          instance = $(this).data('datepicker'),
          date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
        contract_dates.not(this).datepicker('option', option, date);
        $('#Maptodate').val(parsedDate);
        that.map_todate = parsedDate;
      }
    });
  }

  /*move to inventory date*/
  public initializemovetoInventoryPicker() {
    let that = this;
    let strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let contract_dates = $('#movetoInventorydate').datepicker({
      maxDate: new Date(),
      onSelect: function(selectedDate: string) {
        let parsedDate = (selectedDate.split('/')[1] + '-' + strArray[(parseInt(selectedDate.split('/')[0]) - 1)] + '-' + selectedDate.split('/')[2]);
        let option = this.id == 'movetoInventorydate' ? 'minDate' : 'maxDate',
          instance = $(this).data('datepicker'),
          date = $.datepicker.parseDate(instance.settings.dateFormat || $.datepicker._defaults.dateFormat, selectedDate, instance.settings);
        contract_dates.not(this).datepicker('option', option, date);
        that.setEndDatebyStartDate(selectedDate);
        $('#movetoInventorydate').val(parsedDate);
        that.moveto_inventorydate = parsedDate;
      }
    });
  }

  public setEndDatebyStartDate(min_selectedDate: string) {
    $('#movetoInventorydate').datepicker('option', 'minDate', new Date(min_selectedDate));
  }

  public async openAssignTintoPopup(deviceId: string) {
    try {
      await this.getDeviceOnHandDetailsById(deviceId);
      if (!this.deviceOnHand?.device?.CustomerDeviceData || this.deviceOnHand.device.CustomerDeviceData.length === 0) {
        this.toastr.error('Please map this AQU device to Business');
        return;
      }
      this.closePopups();
      this.showAssignTintoPopup = true;
    } catch (error) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  // Assign Tinto Device and update customerDevice.
  public async assignTintoDevice(pairedDeviceId: string) {
    try {
      if (!pairedDeviceId || pairedDeviceId === 'undefined') {
        this.toastr.error('Please Select TINTO Device');
        return;
      }
      if (this.deviceOnHand.device.CustomerDeviceData.length == 0) {
        this.toastr.error('Please map this AQU device to Business');
        this.customerDevice.paired_device_id = undefined;
        this.closePopups();
        return;
      }
      this.customerDevice.id = this.deviceOnHand.device.CustomerDeviceData[0].id;
      this.customerDevice.paired_device_id = pairedDeviceId;
      const updateOnHand = Object.assign({}, this.customerDevice);
      delete updateOnHand.id;
      await this.customerDeviceService.updateOneByID(this.customerDevice.id, updateOnHand);
      this.toastr.success('TINTO Device Assigned successfully');
      this.closePopups();
      this.customerDevice = new CustomerDeviceModel();
      await this.getLocationData();
    } catch (error) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  // De-assign TINTO from AQU and update customerDevice
  public async deAssignTintoDevice() {
    try {
      let deassignDevice = confirm('Are you sure you want to de-assign the device?');
      if (deassignDevice) {
        this.customerDevice.id = this.deviceOnHand.device.CustomerDeviceData[0].id;
        this.customerDevice.paired_device_id = null;
        const updateDeAssignDevice = Object.assign({}, this.customerDevice);
        delete updateDeAssignDevice.id;
        await this.customerDeviceService.updateOneByID(this.customerDevice.id, updateDeAssignDevice);
        this.toastr.success('TINTO Device De-Assigned successfully');
        this.customerDevice = new CustomerDeviceModel();
        await this.getLocationData();
        await this.ngOnInit();
      }
    } catch (error: any) {
      this.toastr.error(error?.error?.message || error?.message || error);
    }
  }

  public async locationChangeData(type: string) {
    this.selectedLocation = type;
    await this.applyFilters();
  }

  public searchDevice(event?: any) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(async () => {
      await this.applyFilters();
    }, 300);
  }

  public async applyFilters() {
    let filtered = [...this.duplicateAquDeviceOnHand];
    if (this.selectedLocation && this.selectedLocation !== 'All' && this.selectedLocation !== '') {
      filtered = filtered.filter(item => item.Location_name === this.selectedLocation);
    }
    if (this.search && this.search.trim()) {
      const term = this.search.replace(/[-_]|\s/g, '').toLowerCase();
      filtered = filtered.filter(item => {
        const devNum = (item?.device?.number || '').replace(/[-_]|\s/g, '').toLowerCase();
        const devSerial = (item?.device?.serial_number || '').replace(/[-_]|\s/g, '').toLowerCase();
        const bizName = (item?.BusinessEntites?.[0]?.businessName || '').replace(/[-_]|\s/g, '').toLowerCase();
        return devNum.includes(term) || devSerial.includes(term) || bizName.includes(term);
      });
    }
    this.aquDeviceOnHand = filtered;
    this.NoDataMessage = this.aquDeviceOnHand.length === 0;
    this.batchLoader?.reset();
    await this.batchLoader?.loadNextBatch(true);
  }
  /*item selection conditions*/
  public selectEvent(item: any) {
    // do something with selected item
    this.businessEntitie.id = item.id;
  }

  public async onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    let businesses = await this.businessEntityService.getAllBusiness();
    this.businessEntities = businesses.filter(obj => {
      return obj.businessType[0] && obj.businessType[0].name != 'Hatchery';
    });
  }

  public async onFocused(e: any) {
    // // do something when input is focused
    let businesses = await this.businessEntityService.getAllBusiness();
    this.businessEntities = businesses.filter(obj => {
      return obj.businessType[0] && obj.businessType[0].name != 'Hatchery';
    });
  }

  /*end item selection conditions*/
  public pageChange(pageNum: number) {
    if (this.isSearchedClicked == false) {
      this.currentpagenum = pageNum;
      this.dupCurrentPageNum = pageNum;
     }
    }
}
